import { useAsyncValidator } from "@vueuse/integrations/useAsyncValidator";
import { ref } from 'vue';
import { useRouter } from "vue-router";

import { useNotificationsStore } from "@/stores/notifications";

import useAxios from "./axios";

export default function useForm(form, endpoint, rules, messages, backUrl, resetForm, multipart = false, errorHandler = () => { }) {
  const axios = useAxios();
  const notificationStore = useNotificationsStore();
  const router = useRouter();

  const { pass, errorFields } = useAsyncValidator(form, rules, {
    validateOption: {
      messages: {
        required: 'Campo obbligatorio',
        string: {
          max: 'Campo troppo lungo',
          range: 'Campo non valido',
        },
        number: {
          min: 'Valore troppo basso',
          max: 'Valore troppo alto',
          range: 'Valore fuori dai limiti',
        },
        types: {
          email: 'Indirizzo email non valido',
          integer: 'Numero non valido'
        }
      }
    }
  });

  const submitted = ref(false);
  const pending = ref(false);

  const createAndBack = async () => {
    submitted.value = true;
    if (!pass.value) {
      notificationStore.pushError("Ci sono alcuni errori");
      return;
    }
    try {
      await create();
      notificationStore.pushSuccess(messages.create);
      router.push(backUrl);
    } catch (e) {
      errorHandler(e)
    }
  };

  const createAndStay = async () => {
    submitted.value = true;
    if (!pass.value) {
      notificationStore.pushError("Ci sono alcuni errori");
      return;
    }

    try {
      await create();
      submitted.value = false;
      resetForm()
      notificationStore.pushSuccess(messages.create);
    } catch (e) {
      errorHandler(e)
    }
  };

  const create = async () => {
    await submit(post);
  };

  const updateAndBack = async () => {
    await update(true);
  };

  const updateAndStay = async () => {
    await update(false);
  };

  const update = async (goBack) => {
    submitted.value = true;
    if (!pass.value) {
      notificationStore.pushError("Ci sono alcuni errori");
      return;
    }

    try {
      await submit(put);
      notificationStore.pushSuccess(messages.update);
      if (goBack) {
        router.push(backUrl);
      }
    } catch (e) {
      errorHandler(e)
    }
  }

  const submit = async (action) => {
    pending.value = true;

    try {
      await action();
      pending.value = false;
    } catch (e) {
      pending.value = false;
      throw e;
    }
  };

  const put = async () => {
    await axios.put("/" + endpoint + "/" + form.uuid, form);
  };

  const post = async () => {
    if (multipart) {
      const formData = new FormData();
      Object.keys(form).forEach((name) => {
        formData.append(name, form[name]);
      })
      await axios.post("/" + endpoint, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
    } else {
      await axios.post("/" + endpoint, form);
    }

  };

  return { submitted, pending, errorFields, createAndBack, createAndStay, updateAndBack, updateAndStay }
}